import React, { useEffect } from "react";
import './index.scss';

import ImgOne from '../../img/projects/Img1.jpg';
import ImgTwo from '../../img/projects/img2-1.png';
import ImgThree from '../../img/projects/Img3.png';
import ImgFour from '../../img/projects/Img4.png';
import ImgFive from '../../img/projects/Img5.png';
import ImgSix from '../../img/projects/Img6.jpg';
import ImgSeven from '../../img/projects/Img7.png';
import ImgEight from '../../img/projects/Img8.png';
import ImgNine from '../../img/projects/Img9.png';
import ImgTen from '../../img/details/detailten/img0Nuevo.png';

import iconDirection from '../../img/projects/Elipse 39.svg';

import { Link } from "react-router-dom";


const ContentProjectsTotal = (props) => {
    useEffect(() => {
        const targets = {
            one: "viewProjectOne",
            two: "viewProjectTwo",
            three: "viewProjectThree",
        };
        const id = targets[props.name];
        if (!id) return;
        const timer = setTimeout(() => {
            const element = document.getElementById(id);
            if (element) element.scrollIntoView({ block: "start", behavior: "smooth" });
        }, 400);
        return () => clearTimeout(timer);
    }, [props.name]);

    return (
        <div className="ContentProjects">
            <div className="ContentProjectsTitle">
                <div className="ContentProjectsLeft">
                    <a href="/projects" style={{ textDecoration: "none", color: "#000" }}>
                        <img loading="lazy" src={iconDirection} alt="React Logo" />
                        Our Work
                    </a>
                </div>
                <div className="ContentProjectsRight">
                    We take pride in your success.
                </div>
            </div>

            <div id='viewProjectTwo'>
                <Link to="/detailtwo" className="ContentProjectsViewImgageTwo">
                    <div className="ContentProjectsViewImgageLeft">
                        <text className="textOne">Reserve Cut</text>
                        <text className="textTwo">Branding Design</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <img src={ImgTwo} alt="Reserve Cut" />
                    </div>
                </Link>
            </div>

            <div id="viewProjectThree">
                <Link to="/detailthree" className="ContentProjectsViewImgageOne">
                    <div className="ContentProjectsViewImgageLeft">
                        <img src={ImgThree} alt="Bluelander" />
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <text className="textOne">Bluelander</text>
                        <text className="textTwo">Re-Branding</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                </Link>
            </div>

            <div>
                <Link to="/detailfour" className="ContentProjectsViewImgageTwo">
                    <div className="ContentProjectsViewImgageLeft">
                        <text className="textOne">Glo Pret</text>
                        <text className="textTwo">Branding Design</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <img src={ImgFour} alt="Glo Pret" />
                    </div>
                </Link>
            </div>

            <div>
                <Link to="/detailfive" className="ContentProjectsViewImgageOne">
                    <div className="ContentProjectsViewImgageLeft">
                        <img src={ImgFive} alt="FTK Beauty Group" />
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <text className="textOne">FTK Beaty Group</text>
                        <text className="textTwo">Re-Branding</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                </Link>
            </div>

            <div>
                <Link to="/detailsix" className="ContentProjectsViewImgageTwo">
                    <div className="ContentProjectsViewImgageLeft">
                        <text className="textOne">Laila</text>
                        <text className="textTwo">Branding Design</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <img src={ImgSix} alt="Laila" />
                    </div>
                </Link>
            </div>

            <div>
                <Link to="/detailseven" className="ContentProjectsViewImgageOne">
                    <div className="ContentProjectsViewImgageLeft">
                        <img src={ImgSeven} alt="Revelwear" />
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <text className="textOne">Revelwear</text>
                        <text className="textTwo">Re-Branding</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                </Link>
            </div>

            <div>
                <Link to="/detaileight" className="ContentProjectsViewImgageTwo">
                    <div className="ContentProjectsViewImgageLeft">
                        <text className="textOne">Exoclinic</text>
                        <text className="textTwo">Branding Design</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <img src={ImgEight} alt="Exoclinic" />
                    </div>
                </Link>
            </div>

            <div>
                <Link to="/detailnine" className="ContentProjectsViewImgageOne">
                    <div className="ContentProjectsViewImgageLeft">
                        <img src={ImgNine} alt="M2C1" />
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <text className="textOne">M2C1</text>
                        <text className="textTwo">Re-Branding</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                </Link>
            </div>

            <div>
                <Link to="/detailten" className="ContentProjectsViewImgageTwo">
                    <div className="ContentProjectsViewImgageLeft">
                        <text className="textOne">ZOEY</text>
                        <text className="textTwo">Branding Design</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <img src={ImgTen} alt="ZOEY" />
                    </div>
                </Link>
            </div>

            <div id='viewProjectOne'>
                <Link to="/detailone" className="ContentProjectsViewImgageOne">
                    <div className="ContentProjectsViewImgageLeft">
                        <img src={ImgOne} alt="Bart Street" />
                    </div>
                    <div className="ContentProjectsViewImgageRight">
                        <text className="textOne">Bart Street</text>
                        <text className="textTwo">Re-Branding</text>
                        <text className="textThree">
                            <div className="Flecha"></div>
                        </text>
                    </div>
                </Link>
            </div>
        </div>
    );
};

export default ContentProjectsTotal;
